import React from 'react'
import { withStyles } from 'material-ui/styles'
import styles from './styles'
import Paper from 'material-ui/Paper'

const UnknownResult = (props) => {
  const {
    classes,
    subtest
  } = props
  return (
    <Paper elevation={1} className={classes.paper}>{subtest} Result Viewer</Paper>
  )
}

export default withStyles(styles)(UnknownResult)



// WEBPACK FOOTER //
// ./src/components/common/results/views/unknown/index.js